Monitoring.Views.Dashboards ||= {}

class Monitoring.Views.Dashboards.MassiveUpdateView extends Backbone.View
  template: JST["backbone/templates/monitoring/dashboards/massive_update"]

  events:
    'click #update': 'update'
    'click #delete': 'delete'
    'click #cancel': 'cancel'
    'click #close': 'cancel'
    'click #create_conversations': 'create_conversations'

  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @onFinish = ->
    @surveyMode = @searchQuery.get('surveyMode')
    @addTagsView = new Customer.Dashboard.SocialContentTagsView list: [], width: '100%', tagsByClientCode: [], onChange: -> @render()
    @removeTagsView = new Customer.Dashboard.SocialContentTagsView list: [], width: '100%', tagsByClientCode: [], onChange: -> @render()
    @addGroupsView = new Customer.Dashboard.SocialContentTagsView list: [], width: '100%', labels: [], onChange: -> @render()
    @removeGroupsView = new Customer.Dashboard.SocialContentTagsView list: [], width: '100%', labels: [], onChange: -> @render()
    @sentimentSelectorView = new Monitoring.Views.Dashboards.SentimentSelectorView
    @addTopicsView = new Customer.Dashboard.SocialContentTagsView list: [], width: '100%', labels: [], onChange: -> @render()
    @removeTopicsView = new Customer.Dashboard.SocialContentTagsView list: [], width: '100%', labels: [], onChange: -> @render()
    @reached_documents = 0
    @modalElement = ''

  clearStatus: ->
    @addTagsView.setTagsByClientCode([])
    @removeTagsView.setTagsByClientCode([])
    @addTagsView.setLabels([])
    @removeTagsView.setLabels([])
    @sentimentSelectorView?.clear()
    @$el.find('#status').val('').trigger("chosen:updated")

  setAddTags: (tags) ->
    @addTagsView.setList(tags)
    @addTagsView.setTagsByClientCode([])
    @addTagsView.render()

  setRemoveTags: (tags) ->
    @removeTagsView.setList(tags)
    @removeTagsView.setTagsByClientCode([])
    @removeTagsView.render()

  setAddGroups: (groups) ->
    @addGroupsView.setList(_.map(groups, (group) -> {code: group, description: group}))
    @addGroupsView.setLabels([])
    @addGroupsView.render()

  setRemoveGroups: (groups) ->
    @removeGroupsView.setList(_.map(groups, (group) -> {code: group, description: group}))
    @removeGroupsView.setLabels([])
    @removeGroupsView.render()

  setTopicsActions: (topics) ->
    labels = []
    _.each(topics, (topic) -> labels = labels.concat(topic.labels))
    @addTopicsView.setList(_.map(topics, (topic) -> {code: topic.id, description: topic.name}))
    @removeTopicsView.setList(_.map(topics, (topic) -> {code: topic.id, description: topic.name}))
    @addTopicsView.setLabels([])
    @removeTopicsView.setLabels([])
    @addTopicsView.render()
    @removeTopicsView.render()

  setOnFinish: (callback) ->
    @onFinish = callback

  onFailure: =>
    document.body.style.cursor = 'default'
    @$el.find("#update, #cancel, #close, #delete, #create_conversations").prop( "disabled", false )
    @$el.find('#update').addClass('warning').text('Update failed, retry?')
    showError(I18n.t('profiling.massive_actions.massive_update.update_failed'))

  resetUpdateButton: ->
    @$el.find('#update').removeClass('warning').text('Update')

  show: ->
    $(@$el).append(@modalElement) if @modalElement
    @modalElement = ''
    @$el.find('#update_all').modal()

  hide: (shouldClearStatus = true) ->
    @clearStatus() if shouldClearStatus
    @$el.find('#update_all').modal('hide')
    setTimeout =>
      @modalElement = @$el.find('#update_all').detach() unless @modalElement
    , 1000

  render: ->
    @canUpdateTopics = window.App.Ability.CanUpdateTopics
    @$el.html(@template({surveyMode: @surveyMode, canUpdateTopics: @canUpdateTopics}))
    @$el.find('#add_tags').html(@addTagsView.render().el)
    @$el.find('#remove_tags').html(@removeTagsView.render().el)
    @$el.find('#add_groups').html(@addGroupsView.render().el)
    @$el.find('#remove_groups').html(@removeGroupsView.render().el)
    @renderSentimentSelector() if @sentimentSelectorView
    @$el.find('#add_topics').html(@addTopicsView.render().el)
    @$el.find('#remove_topics').html(@removeTopicsView.render().el)
    @$el.find('#sentiment').chosen(width: '200px')
    @$el.find('#status').chosen(width: '200px')

    return this

  renderSentimentSelector: ->
    @$el.find('#sentiment-selector').html(@sentimentSelectorView.render().el)

  delete: ->
    swal({
      title: I18n.t('profiling.massive_actions.massive_delete.delete_all', {contentCount: @reached_documents}),
      text: I18n.t('profiling.massive_actions.massive_delete.limit'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: I18n.t('profiling.massive_actions.massive_delete.delete_button'),
      closeOnConfirm: true
    }, =>
      @_sendRequest(_.extend(massive: {delete: true}, @searchQuery.attributes))
    )

  create_conversations: ->
    swal({
      title: I18n.t('profiling.massive_actions.massive_create.create_all', {contentCount: @reached_documents}),
      text: I18n.t('profiling.massive_actions.massive_create.limit'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: I18n.t('profiling.massive_actions.massive_create.create_button'),
      closeOnConfirm: true
    }, =>
      @_sendRequest(_.extend(massive: {create_conversations: true}, @searchQuery.attributes))
    )

  update: ->
    title = I18n.t('profiling.massive_actions.massive_update.update_all', {contentCount: @reached_documents})
    swal({
      title: title,
      text: I18n.t('profiling.massive_actions.massive_update.limit'),
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn-info',
      confirmButtonText: I18n.t('profiling.massive_actions.massive_update.update_button'),
      closeOnConfirm: true
    }, =>
      massive = {
        account_id: Keepcon.currentAccount.id,
        add_tags:  _.map(@addTagsView.getTags(), (tag) -> { code: tag }),
        remove_tags: _.map(@removeTagsView.getTags(), (tag) -> { code: tag }),
        add_groups:  _.map(@addGroupsView.getTags(), (tag) ->  tag),
        remove_groups: _.map(@removeGroupsView.getTags(), (tag) -> tag),
        add_topics:  _.map(@addTopicsView.getTags(), (tag) ->  tag),
        remove_topics: _.map(@removeTopicsView.getTags(), (tag) -> tag),
        review: @$el.find('input#review').prop('checked')
      }
      massive.sentiment = @sentimentSelectorView?.getValue()
      massive.status = @$el.find('#status').val() if @$el.find('#status').val() != ''
      return unless massive.sentiment or massive.status or massive.add_tags.length > 0 or massive.remove_tags.length > 0 or massive.add_groups.length > 0 or massive.remove_groups.length > 0 or massive.add_topics.length > 0 or massive.remove_topics.length > 0 or massive.review
      @_sendRequest(_.extend(massive: massive, @searchQuery.attributes))
    )


  cancel: ->
    @hide(false)

  _sendRequest: (params) ->
    updateJob = new Monitoring.Methods.AsyncJob()
    updateJob.bind('completed', @onFinish)
    updateJob.bind('failed', @onFailure)
    updateJob.start 'massive', params
    @$el.find("#update, #cancel, #close, #delete, #create_conversations").attr('disabled', 'disabled')
    document.body.style.cursor = 'wait'

  setReachedDocument: (documents_count) ->
    @reached_documents = documents_count
